import React, { useEffect, useRef, useCallback } from 'react';

function TelegramLoginButton({ botName, onAuth, buttonSize = 'large', cornerRadius = 8, disabled = false }) {
  const containerRef = useRef(null);
  const callbackRef = useRef(onAuth);

  // Keep callback ref current without re-rendering the widget
  useEffect(() => {
    callbackRef.current = onAuth;
  }, [onAuth]);

  const stableCallback = useCallback((user) => {
    callbackRef.current(user);
  }, []);

  useEffect(() => {
    if (!botName || !containerRef.current) return;

    // Set global callback for the Telegram widget
    window.__telegramLoginCallback = stableCallback;

    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?23';
    script.setAttribute('data-telegram-login', botName);
    script.setAttribute('data-size', buttonSize);
    script.setAttribute('data-radius', String(cornerRadius));
    script.setAttribute('data-onauth', '__telegramLoginCallback(user)');
    script.setAttribute('data-request-access', 'write');
    script.async = true;

    containerRef.current.innerHTML = '';
    containerRef.current.appendChild(script);

    return () => {
      delete window.__telegramLoginCallback;
    };
  }, [botName, buttonSize, cornerRadius, stableCallback]);

  if (!botName) return null;

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '12px',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    />
  );
}

export default TelegramLoginButton;
